import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Questionario";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/questionario")({
  head: () => pageHead({ title: "Questionário pré-consulta | Clara Camille", path: "/questionario", noindex: true }),
  component: Page,
});
